import rules from './rules'

export default {
  data () {
    return {
      formRules: {
        idName: [{ required: true, max: 20, message: '请输入区体育行政部门管理员姓名', trigger: 'blur' }],
        idNumber: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              if (rules.idNumber(value)) {
                callback()
              } else {
                callback(new Error('请输入有效的身份证号'))
              }
            } else {
              callback(new Error('请输入青训中心管理员身份证号'))
            }
          },
          trigger: 'blur'
        }],
        provinceCode: [{ required: true, message: '请选择省份', trigger: 'change' }],
        cityCode: [{ required: true, message: '请选择市', trigger: 'change' }],
        countyCode: [{ required: true, message: '请选择区', trigger: 'change' }],
        organName: [{ required: true,
          validator: (rule, value, callback) => {
            if (value && value.length <= 50) {
              if (this.orgInfo.organShortName && value === this.orgInfo.organShortName) {
                callback(new Error('区体育行政部门全称不能跟区体育行政部门简称一致'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请输入区体育行政部门全称(50个字以内)'))
            }
          },
          trigger: 'blur' }],
        organShortName: [{ required: true,
          validator: (rule, value, callback) => {
            if (value && value.length <= 20) {
              if (this.orgInfo.organName && value === this.orgInfo.organName) {
                callback(new Error('区体育行政部门简称不能跟区体育行政部门全称一致'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请输入区体育行政部门简称(20个字以内)'))
            }
          },
          trigger: 'blur' }],
        phone: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              if (rules.mobile_phone(value)) {
                callback()
              } else {
                callback(new Error('请输入有效的手机号'))
              }
            } else {
              callback(new Error('请输入区体育行政部门管理员手机号'))
            }
          },
          trigger: 'blur'
        }],
        status: [{ required: true, message: '请选择区体育行政部门状态', trigger: 'change' }],
        password: [{ required: false,
          validator: (rule, value, callback) => {
            if (!value) {
              callback()
            } else {
              if (!rules.password(value)) {
                callback(new Error(this.$t('passwordLimit')))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur' }],
        confirmPassword: [{ required: false,
          validator: (rule, value, callback) => {
            if (value) {
              if (this.orgInfo.password) {
                if (value === this.orgInfo.password) {
                  callback()
                } else {
                  callback(new Error('两次密码不一致'))
                }
              } else {
                if (!rules.password(value)) {
                  callback(new Error(this.$t('passwordLimit')))
                } else {
                  callback()
                }
              }
            } else {
              if (this.orgInfo.password) {
                callback(new Error('两次密码不一致'))
              } else {
                callback()
              }
            }
          },
          trigger: 'blur' }],
        organType: [{ required: true, message: '请选择区体育行政部门级别', trigger: 'change' }],
        loginName: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value) {
              if (rules.loginNameTmp(value)) {
                callback()
              } else {
                callback(new Error('用户名以2-5位的小写字母并拼上制定格式组成'))
              }
            } else {
              callback(new Error('请输入会员协用户名'))
            }
          },
          trigger: 'blur'
        }]
      }
    }
  }
}
